import { useLocation } from 'react-router-dom';

/**
 * Composant StructuredData - Ajoute les données structurées JSON-LD pour le SEO
 * Améliore le référencement avec des données structurées
 */
function StructuredData() {
  const location = useLocation();
  const baseUrl = 'https://wotes.org';
  const currentUrl = `${baseUrl}${location.pathname}`;

  // Données structurées pour l'organisation
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Wote',
    alternateName: 'Wote Startup',
    url: baseUrl,
    logo: `${baseUrl}/logo.png`,
    description: 'Wote - Votre partenaire pour la réussite académique et l\'excellence technologique. Services de consultant informatique, solutions IT, orientation académique, projets de fin d\'études et accompagnement de projets.',
    founder: {
      '@type': 'Person',
      name: 'Jonathan KONDE',
      jobTitle: 'Fondateur',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Kinshasa',
        addressCountry: 'CD'
      }
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Kinshasa',
      addressRegion: 'Kinshasa',
      addressCountry: 'CD'
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+243-816-795-203',
      contactType: 'Customer Service',
      availableLanguage: ['French']
    },
    sameAs: [
      // Ajoute tes réseaux sociaux ici
      // 'https://www.facebook.com/wote',
      // 'https://www.linkedin.com/company/wote',
      // 'https://twitter.com/wote'
    ]
  };

  // Données structurées pour le service
  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Consultant Informatique et Solutions IT',
    provider: {
      '@type': 'Organization',
      name: 'Wote'
    },
    areaServed: {
      '@type': 'Country',
      name: 'République Démocratique du Congo'
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Services Wote',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Consultant Informatique'
          }
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Solutions IT'
          }
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Orientation Académique'
          }
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Projets de Fin d\'Études'
          }
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Accompagnement Projets'
          }
        }
      ]
    }
  };

  // Données structurées pour le site web
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Wote',
    url: baseUrl,
    description: 'Wote - Votre partenaire pour la réussite académique et l\'excellence technologique',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${baseUrl}/search?q={search_term_string}`
      },
      'query-input': 'required name=search_term_string'
    }
  };

  // Données structurées pour la page actuelle
  const getPageSchema = () => {
    const schemas = {
      '/': {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Wote - Accueil',
        description: 'Wote - Votre partenaire pour la réussite académique et l\'excellence technologique',
        url: currentUrl,
        mainEntity: {
          '@type': 'Organization',
          name: 'Wote'
        }
      },
      '/services': {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Services Wote',
        description: 'Découvrez nos services : Consultant Informatique, Solutions IT, Orientation Académique, Projets de Fin d\'Études et Accompagnement Projets',
        url: currentUrl
      },
      '/a-propos': {
        '@context': 'https://schema.org',
        '@type': 'AboutPage',
        name: 'À propos de Wote',
        description: 'Découvrez Wote, votre partenaire pour la réussite académique et l\'excellence technologique',
        url: currentUrl
      },
      '/portfolio': {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: 'Portfolio Wote',
        description: 'Découvrez nos réalisations et projets',
        url: currentUrl
      },
      '/temoignages': {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Témoignages Wote',
        description: 'Découvrez ce que nos clients disent de nos services',
        url: currentUrl
      }
    };

    return schemas[location.pathname] || schemas['/'];
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(getPageSchema()) }}
      />
    </>
  );
}

export default StructuredData;

